// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    h0fca6d6cbb0506c0: html `Marktinzicht`,
    h229e7d06093c2f3f: html `ESG en diversiteit`,
    h4b6568de605796be: html `Besturen en governance`,
    h4e84df3b11ed9b4f: html `Hulp en ondersteuning`,
    h722c4148bfbe6706: html `Training en certificeringen`,
    h85f4df4fdcb8beed: html `Risico en strategie`,
    hb6b70f369f25a7ac: html `Naleving en ethiek`,
    hc639dc8eaab7815d: html `Problemen en rapporten`,
    hcd22a6d6c40d8786: html `Audit en analyses`,
    "link-home": `Home`,
    "nav-section-home": `Home`,
    s032cd9f1245d3645: `Spatie`,
    s08e6d298452e8f68: `Audit`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    s0a860146c6f28d97: `Dialoogvenster sneltoetsen openen`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s0ccb779911d414a3: `Asset-inventaris`,
    s14ba513bc8896c24: `Robots`,
    s1534ff9f453525e1: `Eerste cel selecteren`,
    s175d37c8eb04d73e: `Downloads`,
    s1967ea0b8a2b6015: `Geselecteerde cel uitvoeren`,
    s199f5853f4e718f7: `Projecten`,
    s24761a0cc8d9c0aa: `Organisatie`,
    s299dc244af6aadff: `Customer Admin Boards`,
    s2aa747e75ad1b409: `Third-Party Manager`,
    s2b63dc08d32ccb09: `Omhoog scrollen`,
    s2c2b04f2561a1d4b: `Analytics`,
    s2cfcd4e06c146db9: `Dialoogvenster van organisatie wisselen openen`,
    s2e109263b73c12d5: `Licenties`,
    s34d94212c9758944: `Strategie`,
    s353873ecbaa3efe9: `Pijl links`,
    s3736464cf8d6fa08: `Support`,
    s392dc2954562a82b: `Teksteditor`,
    s39cccc90e6fe1d7f: `Probleemmanager`,
    s3ab6763097d7412f: `Equity Invest`,
    s3d5b54e4d176209c: `Laatste dia`,
    s3f809b62bcc2a44c: `Missiecontrole`,
    s45efff328e4d0a4d: `Naar organisaties zoeken`,
    s460bf77c46d93bb4: `Dialoogvenster snelkoppelingen sluiten`,
    s469437ae00d48e37: `De huidige rij uitvouwen`,
    s47de2481b149190a: `Entiteiten`,
    s4802e47fe2e95134: `Optie`,
    s480d27b7a8b69ce5: `Links scrollen`,
    s49ca4bf0e63593da: `Dialoogvensters sluiten`,
    s4b10acae683d2978: `Volledig scherm`,
    s4b81aa9512692c4d: `Zijnavigatie uitvouwen`,
    s523eb9043213ff0d: `Cursief`,
    s56410a6c80d5215c: `Cel naar beneden verplaatsen`,
    s58622fa7922ed03b: `Knop Help-menu`,
    s586d6bd2eca2da93: `Gebruikers`,
    s5a41c3a63f1c18af: `Profielinstellingen`,
    s5b56a21c08c842c4: `Eerste dia`,
    s5c1ecf88259b79f9: `Presentatie`,
    s5cad0782f12d34b2: `Equity`,
    s5d9182f471cf98d1: `Nalevingskaarten`,
    s5d929ff1619ac0c9: `Zoeken`,
    s5db46d120dcba694: `Beoordelingen`,
    s5e27738a2e8eb763: `Aanmelden`,
    s5e8250fb85d64c23: `Sluiten`,
    s5febcd9b311c16fe: `Rechts scrollen`,
    s60565faf8db3a5cb: `Voer dit en alle bovenstaande cellen uit`,
    s62bc518b503d1c76: `Cel hieronder selecteren`,
    s63b6edf663b6a3c5: `Onderstaande cel toevoegen`,
    s6d5cb7af3fa87c78: `Taakvolger`,
    s6db55a42bcb74cfc: `Probleemvolger`,
    s6fb3409caa74b0a4: `Ctrl`,
    s70113bbc33303a81: `Help-menu`,
    s7417792bbe720149: `Opnieuw uitvoeren`,
    s74cb3d66f6a668e1: `Documentatie`,
    s7695095bb106d505: `Accuvio`,
    s7a4f059aaa029719: `Connect`,
    s7cfe12cd14df9950: `Afmelden`,
    s7db511600050e797: `Voer dit en alle onderstaande cellen uit`,
    s7deaf226ff8b192c: `Installatieprogramma's`,
    s7e388025be643d0d: `Enter`,
    s7eb1e34fc5ece4cd: `Profielmenu`,
    s884bcdca26998a48: `Rapporten`,
    s89365ba6fa5cdb97: `Uitvoeren stoppen`,
    s89ba33f94f92f3cc: `Identificatiecampagnes`,
    s8f4be9f086eb530f: `Ongedaan maken`,
    s9021935bcdd703b9: `Een zijpaneel openen`,
    s9373ade6d85b4388: `De huidige rij samenvouwen`,
    s947f21967d65c480: `Marktplaats`,
    s9ab2385df7adbce0: `Een rij markeren`,
    s9dd12575273ac110: `Omlaag scrollen`,
    s9df9510d60035af3: `Profielmenu openen`,
    s9f26843287bb592d: `Groepen`,
    s9fda4232f5e1876a: `Hulp krijgen`,
    sa05b93d8764f88ed: `Risicobeheerder`,
    sa103c8e0c776e11c: `Sneltoetsen aanvragen`,
    sa153c163bc11460d: `Activiteitencentrum`,
    sa35ed9234d3d66ce: `Geen organisaties gevonden`,
    sa4bb7742cdfc214e: `Director Boards`,
    sa872b0bfe51f2d40: `Organisatiestructuur`,
    saed6432f1517ea10: `Assetbeheerder`,
    saf7a5eef69e5bb59: `Pijl omhoog`,
    sb061ff5a347a296e: `Profiel`,
    sb206d700d26b14ff: `Onderstreept`,
    sb21cca7db5de38f3: `Storyboards`,
    sb284cd019b430d1e: `Geen app-specifieke snelkoppelingen beschikbaar.`,
    sb32c8490570a8831: `Overzicht dia's`,
    sb4484b8d878dffff: `Activiteitslogboeken`,
    sb752d83c4e4619bc: str `Wisselen naar ${0}`,
    sb888017adf7992b9: `Diligent Academy`,
    sbd63362a31200ab4: `Ga naar Launchpad`,
    sbda32dab0c54ffdd: `Volgende dia`,
    sbf84c104b8212e06: `Cel hierboven selecteren`,
    sc203eef710f83583: `We ondersteunen geen specifieke snelkoppelingen voor deze app.`,
    sc2873891e8c3be68: `Robotscripteditor`,
    sc835e30bc3bdd2fd: `Cel naar boven verplaatsen`,
    sc8aa5792985e2ba3: `Platforminstellingen`,
    sca1a826088564455: `Resultaten`,
    sca442b5dc0fd394c: `Pijl omlaag`,
    scdd4399eeeacd8f4: `Van organisatie wisselen`,
    sd0864ea6cb6ef22e: `Community`,
    sd0b6082239185272: `Alles selecteren`,
    sd1182e4e6a0ada64: `Policy Manager`,
    sd1b2ae9109b29cf0: `Zijnavigatie`,
    sd1c09a62f063a73b: `Taakbeheerder`,
    sd514ab1c93237dae: `Garantieplannen`,
    sd76505ffae553332: `Onderzoeksportal`,
    sd81eecf773db25fc: `Alle cellen opeenvolgend uitvoeren`,
    sd8f923198e0c5c6a: `Einde`,
    sd90a1e198e1ac71e: `Esc`,
    sd9fb2375a5c991c5: `We ondersteunen geen specifieke snelkoppelingen voor deze app, maar als u suggesties hebt, laat het ons dan weten.`,
    sdc599e1d5c823e75: `Laatste cel selecteren`,
    sdcc5f064d591aefd: `Vorige dia`,
    se2faf168207b0a48: `Raamwerken`,
    se3b4c857f91f80d7: `Sneltoetsen`,
    se65e4e6f3696e997: `Training`,
    se93a3eaf86201ae7: `Shift`,
    sed2d45e3f811c81d: `Basis`,
    see0ef54044d25a50: `Book Admin Boards`,
    sf0d3b85da03d1e55: `Geselecteerde cel verwijderen`,
    sf2d615b20d62225a: `Planner`,
    sf41a0c89409353dc: `Pijl rechts`,
    sf5597bb9f2103d2a: `Activaties`,
    sf7c0eba7c822e3d6: `Vetgedrukt`,
    sf95b10c03a2d5872: `Zijnavigatie openen`,
    sf993c3199fefcb9c: `Alt`,
    sf9b1c0661a02d9f9: `Configuratie`,
    sfc6b9ce43d2c798c: `Tijdpagina's`,
    sfe3d666017079dce: `BoardEffect`,
    "shortcuts-home": `Startpagina`,
};
